module.exports = __webpack_public_path__ + "img/map_Z2.2.A.01.2faa5fb6.svg";